import React, { createContext, useContext, useState } from "react";
import dayjs from "dayjs";

const StateContext = createContext();

export const StateProvider = ({ children }) => {
  const [selectedOrganization, setSelectedOrganization] = useState(
    parseInt(localStorage.getItem("organizationId"))
  );
  // TableInfo
  const [showBillDetails, setShowBillDetails] = useState(false);
  const [openTime, setOpenTime] = useState("");
  const [closeTime, setCloseTime] = useState("");
  const [ordersCount, setOrdersCountTime] = useState("");
  const [duration, setDuration] = useState("");
  const [waiterName, setWaiterName] = useState("");
  const [tableName, setTableName] = useState("");
  const [billAmount, setBillAmount] = useState("");
  const [billId, setBillId] = useState("");
  // SalesInfoTable
  const [dataProducts, setDataProducts] = useState([]);
  const [allSectedProducts, setAllSelectedProducts] = useState([]);
  const [allSectedRestaurants, setAllSelectedRestaurants] = useState([]);
  // DatePicker
  const [startDate, setStartDate] = useState(dayjs().format("YYYY-MM-DD"));
  const [endDate, setEndDate] = useState(dayjs().format("YYYY-MM-DD"));
  // WaitersInfo
  const [showWaiterSalesDetails, setShowWaiterSalesDetails] = useState(false);
  const [showPaymentMethods, setShowPaymentMethods] = useState(
    window.innerWidth > 760 ? true : false
  );
  // AreasInfo
  const [showAreaSalesDetails, setShowAreaSalesDetails] = useState(false);
  // OrdersByDrivers
  const [showOrderDetails, setShowOrderDetails] = useState(false);

  // Admin Organizations
  const [openEditOrganizationModal, setOpenEditOrganizationModal] =
    useState(false);

  // Reservation
  const [clickedTableForReservation, setClickedTableForReservation] = useState(
    []
  );
  const [selectedTimeForReservation, setSelectedTimeForReservation] =
    useState("");
  const [
    showSeatedTimeForReservationTable,
    setShowSeatedTimeForReservationTable,
  ] = useState(false);
  // MyMenuOrders
  const [openMyMenuOrdersInfoModal, setOpenMyMenuOrdersInfoModal] = useState(
    {}
  );

  const value = {
    selectedOrganization,
    setSelectedOrganization,
    // TableInfo
    showBillDetails,
    setShowBillDetails,
    openTime,
    setOpenTime,
    closeTime,
    setCloseTime,
    ordersCount,
    setOrdersCountTime,
    duration,
    setDuration,
    waiterName,
    setWaiterName,
    tableName,
    setTableName,
    billAmount,
    setBillAmount,
    billId,
    setBillId,
    // SalesInfoTable
    dataProducts,
    setDataProducts,
    allSectedProducts,
    setAllSelectedProducts,
    allSectedRestaurants,
    setAllSelectedRestaurants,
    // DatePicker
    startDate,
    setStartDate,
    endDate,
    setEndDate,
    // Admin Organizations
    openEditOrganizationModal,
    setOpenEditOrganizationModal,
    // WaitersInfo
    showWaiterSalesDetails,
    setShowWaiterSalesDetails,
    showPaymentMethods,
    setShowPaymentMethods,
    // AreasInfo
    showAreaSalesDetails,
    setShowAreaSalesDetails,
    // OrdersByDrivers
    showOrderDetails,
    setShowOrderDetails,
    // Reservation
    clickedTableForReservation,
    setClickedTableForReservation,
    selectedTimeForReservation,
    setSelectedTimeForReservation,
    showSeatedTimeForReservationTable,
    setShowSeatedTimeForReservationTable,
    // MyMenuOrders
    openMyMenuOrdersInfoModal,
    setOpenMyMenuOrdersInfoModal,
  };

  return (
    <StateContext.Provider value={value}>{children}</StateContext.Provider>
  );
};

export const useProjectState = () => {
  return useContext(StateContext);
};
